import { apiFetch, authHeader } from '../../shared/api/httpClient';
import { clientHeaders } from '../../shared/lib/device';

export type NotificationItem = {
  id: number | string;
  type?: string;
  template_id?: string;
  title?: string;
  body?: string;
  params?: string | Record<string, unknown>;
  status?: string;
  ts?: number;
  created_at?: number;
  read?: boolean;
  opened_at?: number | null;
  link?: string;
  raffle_event_id?: string | number;
  raffleEventId?: string | number;
  event_id?: string | number;
  eventId?: string | number;
};

export type NotificationsResponse = {
  unread?: number;
  items?: NotificationItem[];
};

export function fetchNotifications(token: string) {
  return apiFetch<NotificationsResponse>('/api/notifications?limit=50', {
    headers: {
      ...clientHeaders(),
      ...authHeader(token),
    },
  });
}

export function markNotificationRead(token: string, id: number | string) {
  return apiFetch<{ ok?: boolean }>(`/api/notifications/${encodeURIComponent(String(id))}/read`, {
    method: 'POST',
    headers: {
      ...clientHeaders(),
      ...authHeader(token),
    },
  });
}

export function markAllNotificationsRead(token: string) {
  return apiFetch<{ ok?: boolean }>('/api/notifications/read-all', {
    method: 'POST',
    headers: {
      ...clientHeaders(),
      ...authHeader(token),
    },
  });
}
